import isNil from 'lodash-es/isNil'
import { StringParam, useQueryParams } from 'use-query-params'

import { useQueryPage } from '@fourthwall/utils'

type FilterParams = {
  status?: string
  stock?: string
}

export const useFilterProducts = () => {
  const { setPage } = useQueryPage()
  const [queryParams, setQueryParams] = useQueryParams({
    status: StringParam,
    stock: StringParam,
  })

  const resetFiltersParams = () => {
    setPage(undefined)
    setQueryParams({
      status: undefined,
      stock: undefined,
    })
  }

  const setFiltersParams = (params: FilterParams) => {
    setPage(undefined)
    setQueryParams(params)
  }

  const hasFilterParams = Object.values(queryParams).some((param) => !isNil(param))

  return { filtersParams: queryParams, setFiltersParams, resetFiltersParams, hasFilterParams }
}
